import axios from "axios";
import {notify} from "@kyvg/vue3-notification";
import rusToLatin from "./../mixins/rusTranslitutil"

export default {
    namespaced: true,

    state: () => ({
        group: {
            group: null,
            childs: null,
        },
        groups: [],
        groupQuotas: {
            course_passings: {free: null, issued: null},
            test_passings: {free: null, issued: null},
            trajectories: {free: null, issued: null}
        },
        excelStaff: [],
        currentGroup: null,
        newStaffForGroup: false,
        newStaffForGroupValue: null,
        productGroup: null,
        attachedReferenceProfiles: [],
        referenceProfileNotification: null,
        reportArchiveLink: null,
        archiveExists: null,
        totalGroupPageCount: null,
        analyticsGroupData: {
            group_1: null,
            group_2: null,
        },
        filters: {
            name: '',
            job_title: '',
            department: '',
            updated_at: '',
            created_at: '',
        },
        filterString: null,
    }),

    mutations: {
        setGroup(state, data) {
            state.group = data
        },
        setNewGroup(state, data) {
            state.group.group = {...data}
        },
        setGroups(state, data) {
            state.groups = data
        },
        setTotalGroups(state, data) {
            state.totalGroupPageCount = data
        },
        addGroup(state, data) {
            if (state.groups) state.groups = [...state.groups, data]
        },
        editGroup(state, data) {
            state.groups = state.groups.map((group) => group.id == data.id ? data : group)
        },
        setGroupUsers(state, data) {
            state.group.users = data
        },
        giveStaffPassings(state, data) {
            state.group.group.users = state.group.group.users.map((staff) => {
                if (data.staffIds.includes(staff.id)) {
                    staff.last_test_passing = {status: "new"};
                }
                return staff;
            })
        },
        takeStaffPassings(state, data) {
            state.group.group.users = state.group.group.users.map((staff) => {
                if (data.staffIds.includes(staff.id)) {
                    staff.last_test_passing = null;
                }
                return staff;
            })
        },
        setExcelStaff(state, data) {
            state.excelStaff = data
        },
        setCurrentGroup(state, data) {
            state.currentGroup = data
        },
        setNewStaffForGroup(state, data) {
            state.newStaffForGroup = data
        },
        setNewStaffForGroupValue(state, data) {
            state.newStaffForGroupValue = data
        },
        setAttachedReferenceProfiles(state, data) {
            state.attachedReferenceProfiles = data
        },
        setNotificationSettings(state, data) {
            state.referenceProfileNotification = data
        },
        giveStaffCourses(state, data) {
            const usersWithCourse = state.group.group.users.map((user) => {
                if (!data.staffIds.includes(user.id)) return user;
                else {
                    user.course_passings.push({name: data.name.text, status: "new", external_id: data.course})
                    return user;
                }
            })
            state.group = {group: {...state.group.group, users: usersWithCourse}}
        },
        giveStaffTrajectory(state, data) {
            let trajectoriesFree = state.groupQuotas.trajectories.free.map((trajectories) => {
                return {...trajectories, count: trajectories.count - data.count}
            });
            let trajectoriesIssued = state.groupQuotas.trajectories.issued.map((trajectories) => {
                return {...trajectories, count: +trajectories.count + +data.count}
            })
            state.groupQuotas = {
                ...state.groupQuotas,
                trajectories: {free: trajectoriesFree, issued: trajectoriesIssued}
            };
        },
        takeStaffTrajectory(state, data) {
            let trajectoriesIssued = state.groupQuotas.trajectories.issued.map((trajectories) => {
                return {...trajectories, count: trajectories.count - data.count}
            })
            let trajectoriesFree = state.groupQuotas.trajectories.free.map((trajectories) => {
                return {...trajectories, count: +trajectories.count + +data.count}
            })
            state.groupQuotas = {
                ...state.groupQuotas,
                trajectories: {free: trajectoriesFree, issued: trajectoriesIssued}
            };
        },
        takeStaffCourses(state, data) {
            const usersWithoutCourse = state.group.group.users.map((user) => {
                if (!data.staffIds.includes(user.id)) return user;
                else {
                    user.course_passings = user.course_passings.filter((course) => course.external_id !== data.course)
                    return user;
                }
            })
            state.group = {group: {...state.group.group, users: usersWithoutCourse}}
        },
        setGroupQuotas(state, data) {
            state.groupQuotas = data;
        },
        setProductGroup(state, data) {
            state.productGroup = data;
        },
        setLink(state, data) {
            state.reportArchiveLink = data;
            state.archiveExists = null;
        },
        setArchiveExists(state, data) {
            state.archiveExists = data;
        },
        setAnalyticsGroupData(state, data) {
            state.analyticsGroupData = data;
        },
        clearAnalyticsGroupData(state) {
            state.analyticsGroupData = {
                group_1: null,
                group_2: null,
            }
        },
        setFilters(state, data) {
            state.filters = data.filters;
            state.filterString = data.filterString;
        },
        clearFilters(state) {
            state.filters = {
                name: '',
                job_title: '',
                department: '',
                updated_at: '',
                created_at: '',
            };
            state.filterString = null;
        }
    },

    actions: {
        async createGroup({commit}, request) {
            await axios.post(`/groups`, request).then(({data}) => {
                commit("setNewGroup", data)
            })
        },
        async getGroup({commit}, id) {
            await axios.get(`/groups/${id}`)
                .then(({data}) => {
                    commit("setGroup", data)
                })

        },
        async getGroups({commit}, company_id) {
            await axios.get(`/groups` + (company_id ? `?company_id=${company_id}` : ''))
                .then(({data}) => {
                    commit("setGroups", data)
                })
        },
        async searchGroups({commit}, data) {
            await axios.post('/groups/searchGroups', data)
                .then(({data}) => {
                    commit("setGroups", data.groups)
                    commit("setTotalGroups", data.meta.total)
            });
        },
        async updateGroup({commit}, request) {
            await axios.put(`/groups/${request.id}`, request.group);
        },
        async deleteGroups({commit}, groups) {
            await axios.post(`/groups/delete`, {
                groups: groups,
            });
        },
        async mergeGroups({commit}, groups) {
            await axios.post('/groups/mergeGroups', groups);
        },
        async copyGroup({commit}, groupData) {
            await axios.post('/groups/copy', groupData).then(({data}) => {
                commit("setNewGroup", data);
            });
        },
        async updateGroupUsers({commit}, data) {
            await axios.put(`/groups/${data.id}/users`, {users: data.users})
                .then(({data}) => {
                    commit("setGroupUsers", data)
                    notify({
                        title: "Данные сохранены",
                        type: "success"
                    })
                })
        },
        async addUsersToGroup({commit}, data) {
            await axios.post(`/groups/${data.groupId}/add/users`, data.data);
        },
        async giveStaffPassings({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/test/${data.reportType}/append`, {users: data.staffIds})
                .then(() => {
                    commit("giveStaffPassings", data)
                    notify({
                        type: "success",
                        title: "Тесты были выданы"
                    })
                })
        },
        async allowToViewReport({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/allow_view_report`, {users: data.staffIds}).then(() => {
                notify({
                    type: "success",
                    title: "Ссылки отправлены на email"
                })
            })
        },
        async takeStaffPassings({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/test/remove`, {users: data.staffIds})
                .then(() => {
                    commit("takeStaffPassings", data)
                    notify({
                        type: "success",
                        title: "Операция прошла успешно"
                    })
                })
        },
        async giveStaffCourses({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/course/${data.course}/${data.source}/append`, {users: data.staffIds})
                .then(() => {
                    commit("giveStaffCourses", data)
                    notify({
                        type: "success",
                        title: "Курсы были выданы"
                    })
                })
        },
        async giveStaffTrajectory({commit}, data) {
            await axios.put(`/groups/${data.id}/trajectories/append`, {users: data.staffIds})
                .then(() => {
                    commit("giveStaffTrajectory", data)
                    notify({
                        type: "success",
                        title: "Траектории были выданы"
                    })
                })
        },
        async takeStaffTrajectory({commit}, data) {
            await axios.put(`/groups/${data.id}/trajectories/remove`, {users: data.staffIds})
                .then(() => {
                    commit("takeStaffTrajectory", data)
                    notify({
                        type: "success",
                        title: "Траектории были удалены"
                    })
                })
        },
        async takeStaffCourses({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/course/${data.course}/remove`, {users: data.staffIds})
                .then(() => {
                    commit("takeStaffCourses", data)
                    notify({
                        type: "success",
                        title: "Операция прошла успешно"
                    })
                })
        },
        async loadGroupFromExcel({commit}, data) {
            let request = new FormData()
            request.append("file", data.file)
            if (data.group_id) request.append("group_id", data.group_id)
            if (data.password_change) request.append("password_change", 1)
            await axios.post(`/users/downloads/excel`, request).then(({data}) => {
                commit("setExcelStaff", data)
            })
        },
        async getCurrentGroup({commit}) {
            await axios.get(`/groups/current`)
                .then(({data}) => {
                    commit("setCurrentGroup", data)
                })
        },
        // eslint-disable-next-line no-unused-vars
        async remindAboutTest({commit}, data) {
            await axios.put(`/groups/${data.id}/passing/reminder`, {users: data.staffIds})
                .then(() => {
                    notify({
                        title: "Напоминания отправлены",
                        type: "success"
                    })
                })
        },
        async getGroupQuotas({commit}, id) {
            await axios.get(`/groups/${id}/quota`)
                .then(({data}) => {
                    commit("setGroupQuotas", data)
                })
        },
        async getReportsArchive({commit}, data) {
            await axios.post(`/groups/${data.group}/passing/download_reports`, {passings: data.codes}).then((response) => {
                commit("setLink", response.data);
            })
        },
        async checkArchiveExists({commit},data) {
            await axios.post(`test/passings/archive/exists`, {file: data}).then((response) => {
                commit("setArchiveExists", response.data.exists);
            });
        },
        async getReport({commit}, data) {
            await axios.post(`/groups/passing/download_report`, {passings: data.passing, type: data.type}).then((response) => {
                let link = document.createElement('a');
                link.href = response.data;
                link.target = "_blank";
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
        },
        async getProductGroup({commit}, data) {
            let searchQuery = '';
            if (data.search_data) {
                searchQuery = '?'
                for (const [key, value] of Object.entries(data.search_data)) {
                    if (value && value !== 'Не выбрано' && value !== '0') {
                        searchQuery += `${key}=${value}&`;
                    }
                }
            }

            await axios.get(`groups/${data.id}/${data.product}${(searchQuery)}`)
                .then(({data}) => {
                    commit("setProductGroup", data)
                })
        },
        async getAttachedToGroupReferenceProfiles({commit}, id) {
            await axios.get(`reference_profiles/attached/${id}`)
                .then(({data}) => {
                    commit("setAttachedReferenceProfiles", data)
                })
        },
        async getNotificationSettings({commit}, id) {
            await axios.get(`groups/reference_profiles/get_notification_settings/${id}`)
                .then(({data}) => {
                    commit("setNotificationSettings", data)
                })
        },
        async attachReferenceProfile({commit}, data) {
            await axios.get(`groups/reference_profiles/attach/${data.group_id}/${data.profile_id}`)
                .then(({data}) => {
                    commit("setAttachedReferenceProfiles", data)
                    notify({
                        title: "Профиль прикреплён",
                        type: "success"
                    })
                }).catch((error) => {
                    notify({
                        title: "Ошибка",
                        type: "error"
                    })
                })
        },
        async detachReferenceProfile({commit}, data) {
            await axios.get(`groups/reference_profiles/detach/${data.group_id}/${data.profile_id}`)
                .then(({data}) => {
                    commit("setAttachedReferenceProfiles", data)
                    notify({
                        title: "Профиль откреплён",
                        type: "success"
                    })
                }).catch((error) => {
                    notify({
                        title: "Ошибка",
                        type: "error"
                    })
                })
        },
        async updateNotificationSettings({commit}, data) {
            await axios.post(`/groups/set_reference_profile_notification/${data.group_id}`, {sendNotification: data.sendNotification})
                .then(() => {
                    notify({
                        title: "Найстройки сохранены",
                        type: "success"
                    })
                })
        },
        async toggleAllowViewReport({commit}, data) {
            await axios.post('/groups/passing/allow-view-report', data)
                .then(() => {})
        },
        async remindAboutPassings({commit}, data) {
            await axios.post(`/groups/remind`, data);
        },
        async syncGroupsForUser({commit}, data) {
            await axios.post(`/groups/sync/${data.userId}`, data.data)
        },
        setAnalyticsGroupData({commit}, data) {
            commit("setAnalyticsGroupData", data);
        },
        clearAnalyticsGroupData({commit}) {
            commit('clearAnalyticsGroupData');
        },
        setGroupFilters({commit}, data) {
            commit('setFilters', data)
        },
        clearGroupFilters({commit}) {
            commit('clearFilters');
        }
    }
}